import Web3 from 'web3'

import type { IProvider } from '@web3auth/base'

const getChainId = async (provider: IProvider): Promise<string> => {
  try {
    const web3 = new Web3(provider as any)

    // Get the connected Chain's ID
    const chainId = await web3.eth.getChainId()

    return chainId.toString()
  } catch (error) {
    return error as string
  }
}

const getAccounts = async (provider: IProvider): Promise<any> => {
  try {
    const web3 = new Web3(provider as any)

    // Get user's Ethereum public address
    return await web3.eth.getAccounts()
  } catch (error) {
    return error
  }
}

const getBalance = async (provider: IProvider): Promise<string> => {
  try {
    const web3 = new Web3(provider as any)

    // Get user's Ethereum public address
    const accounts = await web3.eth.getAccounts()
    const address = accounts[0]

    // Get user's balance in ether'
    const balanceWei = await web3.eth.getBalance(address)
    return web3.utils.fromWei(
      balanceWei, // Balance is in wei
      'ether'
    )
  } catch (error) {
    return error as string
  }
}

const signMessage = async (provider: IProvider): Promise<string> => {
  try {
    const web3 = new Web3(provider as any)

    // Get user's Ethereum public address
    const accounts = await web3.eth.getAccounts()
    const fromAddress = accounts[0]

    const originalMessage = 'YOUR_MESSAGE'

    // Sign the message
    return await web3.eth.personal.sign(
      originalMessage,
      fromAddress,
      'test password!' // configure your own password here.
    )
  } catch (error) {
    return error as string
  }
}

const getPrivateKey = async (provider: IProvider): Promise<string> => {
  try {
    // Get user's Ethereum public address
    return (await provider.request({
      method: 'eth_private_key',
    })) as string
  } catch (error) {
    return error as string
  }
}

const sendTransaction = async (provider: IProvider): Promise<any> => {
  try {
    const web3 = new Web3(provider as any)

    // Get user's Ethereum public address
    const accounts = await web3.eth.getAccounts()
    const fromAddress = accounts[0]

    const destination = fromAddress

    const amount = web3.utils.toWei('0.001', 'ether') // Convert 1 ether to wei
    let transaction = {
      from: fromAddress,
      to: destination,
      data: '0x',
      value: amount,
    }

    // calculate gas transaction before sending
    transaction = {
      ...transaction,
      gas: await web3.eth.estimateGas(transaction),
    } as any

    // Submit transaction to the blockchain and wait for it to be mined
    const receipt = await web3.eth.sendTransaction(transaction)

    return JSON.stringify(
      receipt,
      (key, value) => (typeof value === 'bigint' ? value.toString() : value) // return everything else unchanged
    )
  } catch (error) {
    return error as string
  }
}

export default {
  getChainId,
  getAccounts,
  getBalance,
  sendTransaction,
  signMessage,
  getPrivateKey,
}
